import { render, staticRenderFns } from "./new3.vue?vue&type=template&id=2faf5ae8&scoped=true"
import script from "./new3.vue?vue&type=script&lang=js"
export * from "./new3.vue?vue&type=script&lang=js"
import style0 from "./new3.vue?vue&type=style&index=0&id=2faf5ae8&prod&scoped=true&lang=css"
import style1 from "./new3.vue?vue&type=style&index=1&id=2faf5ae8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faf5ae8",
  null
  
)

export default component.exports